import React from 'react';
import { Box } from '@mui/material';

const StatusDot = ({ status }) => {
  const colorFor = (s) => {
    if (s === 'scheduled') return 'info.main';
    if (s === 'confirmed') return 'success.main';
    if (s === 'in_progress') return 'primary.main';
    if (s === 'completed') return 'success.main';
    if (s === 'no_show') return 'error.main';
    if (s === 'cancelled') return 'text.disabled';
    return 'text.secondary';
  };
  return (
    <Box
      sx={{
        width: 8,
        height: 8,
        borderRadius: '50%',
        bgcolor: colorFor(status),
        flexShrink: 0,
      }}
    />
  );
};

export default StatusDot;
